import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Typography,
  VertBreadcrumb,
  VertContainer,
  VertIcon,
  VertLoading,
  VertPagination
} from '@vertem-core/vertice-ds';
import {
  Col,
  Row
} from 'antd';
import VertCardProductContainer from 'components/VertCardProductContainer/VertCardProductContainer';
import 'Assets/styles/default/pages/showcase/ShowcaseStyles.less';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useParams } from 'react-router-dom';
import {
  LoadShowCaseList,
} from 'redux/Reducers/Showcases/ShowcaseListReducer';

const ShowcasePage = () => {
  const mediaQuery = useMediaQuery({ query: '(max-width: 580px)' });
  const dispatch = useDispatch();
  const pageSize = 20;
  const params = useParams();

  const {
    isLoading,
    error,
    list,
    totalCount,
    totalPages,
  } = useSelector((state) => state.ShowcaseList);

  useEffect(() => {

    if (params.identifier) {
      loadShowCase();
    }
  }, [params.identifier]);

  const loadShowCase = (pageNumber = 1) => {
    var payload = { identifier: params.identifier, pageSize, pageNumber };
    dispatch(LoadShowCaseList(payload));
  }

  const headerAndFooterHeightSum = () => {
    var headerDesktopHeight = document.querySelector(".header-desktop-container")?.offsetHeight ?? 0;
    var headerMobileHeight = document.querySelector(".header-mobile-container")?.offsetHeight ?? 0;
    var footerHeight = document.querySelector(".GenericFooter")?.offsetHeight ?? 0;
    return (headerDesktopHeight + headerMobileHeight + footerHeight);
  }

  const headerFooterAndTitleHeightSum = () => {
    var headerDesktopHeight = document.querySelector(".header-desktop-container")?.offsetHeight ?? 0;
    var headerMobileHeight = document.querySelector(".header-mobile-container")?.offsetHeight ?? 0;
    var footerHeight = document.querySelector(".GenericFooter")?.offsetHeight ?? 0;
    var titleHeight = document.querySelector(".container-title-breadcrumb")?.offsetHeight ?? 0;
    return (headerDesktopHeight + headerMobileHeight + footerHeight + titleHeight);
  }

  const vertCardProductContainer = (item) => {
    const cardProduct = { ...item, vendor: item.vendor, vendorId: item?.vendor?.id, productUrl: `/product/${item.sku}`, };
    return <VertCardProductContainer cardProduct={cardProduct} />
  }

  return (

    <VertContainer className='container-showcase'>

      <div style={{
        minHeight: `calc(100vh - ${headerAndFooterHeightSum()}px)`
      }}>
        <VertContainer spacingY="small" className='container-title-breadcrumb'>

          <VertBreadcrumb hasBackButton={true}
            items={[
              {
                key: 'home',
                title: <Link to="/">Início</Link>
              },
              {
                className: 'breadcrumb-link-active',
                key: 'busca',
                title: <Link to="">Busca</Link>
              }
            ]}
            template="marketplace"
          />

          <div className='container-title'>
            <Typography.Text className='text-title'>
              Resultado da Busca
            </Typography.Text>
          </div>

        </VertContainer>

        <div style={{ minHeight: `calc(100vh - ${headerFooterAndTitleHeightSum()}px)` }}
          className='main-container-showcase'
        >
          {
            isLoading ?
              <div className='container-loading'>
                <VertLoading type="spin" size="small" />
              </div>
              :
              <>
                {
                  (!list.length || error) ?
                    <div className='container-products-not-found'>
                      <VertIcon className='icon-search-not-found' size="large" isVertice iconName='Search' />
                      {!mediaQuery ?
                        <>
                          <Typography.Text className='text-search-not-found'>
                            Desculpe! Não encontramos nenhum resultado
                          </Typography.Text>
                          <Typography.Text className='text-search-not-found'>
                            para a sua busca.
                          </Typography.Text>
                        </> :
                        <Typography.Text className='text-search-not-found text-align-center'>
                          Desculpe! Não encontramos nenhum resultado
                          para a sua busca.
                        </Typography.Text>
                      }

                    </div>
                    :
                    <Row gutter={8}>
                      {
                        list.map(item => (
                          <Col key={item.sku} xs={12} sm={12} md={6} lg={6} xl={6} >
                            {vertCardProductContainer(item)}
                          </Col>
                        ))
                      }
                    </Row>
                }
              </>
          }
          <div className='container-items-showcase'>
            <Row justify="center" align="middle">
              <Col className="col text-center">
                <VertPagination
                  onChange={(pageNumber) => loadShowCase(pageNumber)}
                  defaultCurrent={1}
                  simple={false}
                  total={totalCount}
                  showSizeChanger={false}
                  showLessItems
                  pageSize={pageSize}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </VertContainer>
  )
}

export default ShowcasePage;
